import { useId } from 'react';

const useUniqueId = (name = 'button') => {
    const id = useId();
    return `${name}-${id}`;
};

export { useUniqueId };
//# sourceMappingURL=useUniqueId.js.map
